import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RootDirective, SvgDirective } from '@pure/hive';
import { NvmeNowRenderInfo } from '../../../../data/models/recommendations.models';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const NVME_NOW_CARD_PLUGIN_NAME = 'NvmeNowCardPluginComponent';

/**
 * Plugin component for the NVMe Now (prorec-nvme-now) recommendation card body.
 *
 * The card shell (target name, header badge, dismiss, footer button) is provided
 * by `RecommendationCardTemplateComponent`. This plugin only owns the middle body:
 * the marketing message, the trade-up graphic, and the "Plan upgrade from SAS to NVMe…"
 * call-to-action.
 */
@Component({
    selector: 'nvme-now-card-plugin',
    templateUrl: './nvme-now-card-plugin.component.html',
    styleUrls: ['./nvme-now-card-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RootDirective, SvgDirective],
})
export class NvmeNowCardPluginComponent {
    renderInfo = input.required<NvmeNowRenderInfo>();
}

registerAsCardPlugin(NVME_NOW_CARD_PLUGIN_NAME, NvmeNowCardPluginComponent);
